"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
  query ProgressCollection($from: String!, $to: String!, $userId: Int!) {
    progressCollection(range: { from: $from, to: $to }, userId: $userId) {
      lifeJournalEntry {
        id
        title
        note
        media {
          ... on PhotoMedia {
            sizes {
              large {
                url
              }
              thumbnail {
                url
              }
            }
          }
        }
      }
      date
    }
  }
`;
//# sourceMappingURL=getLifeJournalEntries.js.map